import ACBadRequestError from 'academy-common-lib/components/error/ACBadRequestError';
import ACForbiddenError from 'academy-common-lib/components/error/ACForbiddenError';
import ACMissingContentError from 'academy-common-lib/components/error/ACMissingContentError';
import Raven from 'raven-js';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
const ApiError = ({
  to,
  href,
  className,
  error,
  notFoundErrorMarker,
  forbiddenErrorMarker,
  errorMarker
}) => {
  const errorStatus = (error === null || error === void 0 ? void 0 : error.status) || 500;
  useEffect(() => {
    if (![404, 403].includes(errorStatus)) {
      Raven.captureException(error);
    }
  }, [error, errorStatus]);
  switch (errorStatus) {
    case 404:
      return /*#__PURE__*/_jsx(NavMarker, {
        name: notFoundErrorMarker,
        children: /*#__PURE__*/_jsx(ACMissingContentError, {
          className: className,
          href: href,
          to: to
        })
      });
    case 403:
      return /*#__PURE__*/_jsx(NavMarker, {
        name: forbiddenErrorMarker,
        children: /*#__PURE__*/_jsx(ACForbiddenError, {
          className: className,
          href: href,
          to: to
        })
      });
    default:
      return /*#__PURE__*/_jsx(NavMarker, {
        name: errorMarker,
        children: /*#__PURE__*/_jsx(ACBadRequestError, {
          className: className,
          href: href,
          to: to
        })
      });
  }
};
export default ApiError;